import { Environment } from '../../config/env-config';
import { JSONPath } from 'jsonpath-plus';
import {
  ITokenClaims,
  TokenCustomClaimKeysEnum,
} from '../../domains/auth0/types';

interface ReplacementsTypes {
  replacements: {
    source: any;
    key: any;
  }[];
  jsonPath: string;
  resources: any;
  options: { env: Environment; tokenClaims?: ITokenClaims };
}

/**
 * It is used to retrieve json values via schema keys or schema - dynamic keys that needs interpolation
 * @param replacements ReplacementType
 * @param jsonPath jsonPath query string or any string with interpolate values
 * @param resources json resource, could be json data or tenant data,
 * @param options additional options like environment
 */
export function getReplacementValues({
  replacements,
  jsonPath,
  resources,
  options,
}: ReplacementsTypes) {
  const replacementValues = replacements.map((rs) => {
    const { source, key } = rs;
    let finalJsonPath = source.jsonPath;

    // if a replacement has another replacement dependency do recursive replacement
    if (source.replacements) {
      const { resultString: newJsonPath } = getReplacementValues({
        replacements: source.replacements,
        jsonPath: source.jsonPath,
        resources,
        options,
      });
      finalJsonPath = newJsonPath;
    }

    const keyValue = JSONPath({
      json: resources[source.resource || '_self'],
      path: systemicPathExpressions(finalJsonPath, options) ?? finalJsonPath,
    });

    if (Array.isArray(keyValue)) {
      if (keyValue.length === 0) {
        return { key, keyValue: 'invalid_interpolation' };
      }
      return { key, keyValue: keyValue };
    }

    return { key, keyValue: keyValue || 'invalid_interpolation' };
  });

  (replacementValues || []).forEach(({ key, keyValue }) => {
    jsonPath = jsonPath.replace(`{${key}}`, keyValue);
  });

  return { replacementValues, resultString: jsonPath };
}

// Systemic `environment` replacement
function systemicPathExpressions(str: string, obj: any) {
  return str
    .replace(/(?:#env#)/, () => {
      return obj.env;
    })
    .replace(/(?:#org_id#)/, () => {
      return TokenCustomClaimKeysEnum.ORG_ID;
    });
  // Add more systemic replacement expressions here with piping for instance .str.replace(searchValue, callback)
}
